// "The lesson loop": a speech bubble drawn as the handbook's 40-minute lesson —
// warm-up 5 · main 15 · practice 15 · wrap-up 5 — with an AI spark inside.
// It always sits on its own chalkboard tile in chalk colours, in both themes, so it reads as a badge.
// On first render the segments draw in lesson order, then the spark appears (once; off for reduced motion).
const BUBBLE = "M14 5 H34 A9 9 0 0 1 43 14 V25 A9 9 0 0 1 34 34 H15 L5 43 V14 A9 9 0 0 1 14 5 Z";
const TOTAL = 40;
const GAP = 1.3;
const SEGMENTS = [
  { kind: "warmup", start: 0, len: 5 },
  { kind: "main", start: 5, len: 15 },
  { kind: "practice", start: 20, len: 15 },
  { kind: "wrapup", start: 35, len: 5 },
] as const;
const SPARK = "M24 11.5 C24.9 16.6 25.9 17.6 31 18.5 C25.9 19.4 24.9 20.4 24 25.5 C23.1 20.4 22.1 19.4 17 18.5 C22.1 17.6 23.1 16.6 24 11.5 Z";

export function Logo({ size = 34, animate = true, title }: { size?: number; animate?: boolean; title?: string }) {
  return (
    <svg className={`logo${animate ? " logo-animate" : ""}`} width={size} height={size} viewBox="0 0 48 48" fill="none"
      role={title ? "img" : undefined} aria-hidden={title ? undefined : true} aria-label={title}>
      <rect className="logo-tile" x="0.5" y="0.5" width="47" height="47" rx="11" />
      <g transform="translate(3.6 3.2) scale(.85)">
      {SEGMENTS.map((s, i) => {
        const dash = s.len - GAP;
        return (
          <path key={s.kind} d={BUBBLE} pathLength={TOTAL} className={`logo-seg logo-${s.kind}`}
            strokeWidth={5.6} strokeLinecap="round" strokeLinejoin="round"
            strokeDasharray={`${dash} ${TOTAL}`} strokeDashoffset={-(s.start + GAP / 2)}
            style={{ ["--dash" as string]: dash, animationDelay: `${120 + i * 170}ms` }} />
        );
      })}
      <path d={SPARK} className="logo-spark" />
      <circle cx="33" cy="12" r="1.9" className="logo-dot" />
      </g>
    </svg>
  );
}
